import axios from 'axios'
import { FiltresListeAvisPostModel, FiltresListeAvisResponseModel } from '../types/filtresListeAvisModel'

export const getListeAvis = (data: FiltresListeAvisPostModel): Promise<FiltresListeAvisResponseModel> => axios.post('/api/avis/list', data)
	.then((response) => response.data)
